<template>
  <v-card :class="cardClass">
    <v-card-title class="mb-5 primary white--text">
      Professional Information
    </v-card-title>
    <v-card-text class="pb-0">
      <v-form ref="professionalInfo">
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-file-input
              show-size
              label="Upload Driving License"
              prepend-icon="mdi-file-document"
              v-model="licence"
              required
              @change="onLicenceChange"
            />
            <v-btn text :href="user.get('uploadLicence')" target="_blank">
              Current Document
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="userType === 'instructor'">
            <v-file-input
              show-size
              label="Upload Instructor License"
              prepend-icon="mdi-file-document"
              required
              v-model="instructorLicence"
              @change="onInstructorLicenceChange"
            />
            <v-btn
              text
              :href="user.get('uploadInstructorLicence')"
              target="_blank"
            >
              Current Document
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" class="py-0" v-if="userType === 'instructor'">
            <v-file-input
              show-size
              label="Upload Driver Abstract"
              prepend-icon="mdi-file-document"
              required
              v-model="instructorDriverAbstract"
              @change="onInstructorDriverAbstractChange"
            />
            <v-btn
              text
              :href="user.get('instructorDriverAbstract')"
              target="_blank"
            >
              Current Document
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" class="py-0" v-if="userType === 'instructor'">
            <v-file-input
              show-size
              label="Upload Instructor Safety"
              prepend-icon="mdi-file-document"
              required
              v-model="instructorSafety"
              @change="onInstructorSafetyChange"
            />
            <v-btn text :href="user.get('instructorSafety')" target="_blank">
              Current Document
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" class="py-0" v-if="userType === 'instructor'">
            <v-file-input
              show-size
              :label="user.get('contract')"
              prepend-icon="mdi-file-document"
              required
              v-model="instructorSafety"
              @change="onInstructorSafetyChange"
              disabled
            />
            <v-btn text :href="user.get('contract')" target="_blank">
              Contract Document
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" class="py-0" v-if="userType === 'instructor'">
            <v-file-input
              show-size
              label="Insurance With 2 Mill Liability"
              prepend-icon="mdi-file-document"
              required
              v-model="instructor2MilLiability"
              @change="onInstructor2MilLiabilityChange"
            />
            <v-btn
              text
              :href="user.get('instructor2MilLiability')"
              target="_blank"
            >
              Current Document
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="userType === 'instructor'">
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Instructing Car Plate Number"
              prepend-icon="mdi-car"
              type="text"
              :rules="fieldRules"
              v-model="carPlateNumber"
              hint="If you have more than one plate number, please use comman to separate them"
              required
            />
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Instructing Plate Number"
              prepend-icon="mdi-speedometer"
              type="text"
              :rules="fieldRules"
              v-model="instructingPlateNumber"
              required
            />
          </v-col>
        </v-row>

        <!-- <v-autocomplete
          v-if="userType === 'instructor'"
          :items="filteredSchools"
          item-text="attributes.name"
          item-value="id"
          label="School"
          prepend-icon="mdi-school"
          v-model="school"
          :search-input.sync="populateSchools"
          hide-no-data
        />
        <v-checkbox
          class="mt-0"
          label="Your school not showing up? You can operate independently on your
          own, please click the checkbox here"
          color="indigo"
          v-model="notWithAnySchool"
          v-if="userType === 'instructor'"
        />-->

        <v-text-field
          v-if="userType === 'instructor'"
          :items="filteredCities"
          v-model="cities"
          prepend-icon="mdi-city-variant"
          label="Cities"
          :rules="fieldRules"
          disabled
        />
        <!-- <v-autocomplete
          v-if="userType === 'instructor'"
          :items="filteredCities"
          v-model="cities"
          prepend-icon="mdi-city-variant"
          label="Cities"
          :rules="fieldRules"
          multiple
          chips
          small-chips
          deletable-chips
          hide-selected
          :search-input.sync="populateCities"
          hide-no-data
        /> -->
      </v-form>
    </v-card-text>
    <v-card-actions class="px-5 pb-5">
      <v-spacer />
      <small>***You are associated with 'The DriverX School'</small>
      <v-spacer />
      <v-btn @click="submit" color="primary" depressed>Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Parse from 'parse'
import { mapGetters, mapActions } from 'vuex'
import rawCities from 'cities.json'
import validationRules from '@/validation-rules'

const selectedCities = rawCities
  .filter(({ country }) => country === 'CA')
  .map(({ name }) => name)

export default {
  props: {
    cardClass: {
      type: String,
      default: ''
    }
  },
  data () {
    this.filteredCities = [...new Set(selectedCities)]
    return {
      licenceNumber: '',
      licence: null,
      instructorLicence: null,
      instructorDriverAbstract: null,
      instructorSafety: null,
      instructor2MilLiability: null,
      licenceURL: '',
      instructorLicenceURL: '',
      instructor2MilLiabilityURL: '',
      instructorDriverAbstractURL: '',
      instructorSafetyURL: '',
      carPlateNumber: '',
      uploadLicence: '',
      cities: [],
      school: '',
      instructingPlateNumber: '',
      ...validationRules,
      populateCities: null,
      filteredCityEntries: [],
      populateSchools: null,
      filteredSchoolsEntries: [],
      currentSchoolId: null,
      currentInstructorSchoolId: null,
      userType: '',
      notWithAnySchool: false
    }
  },
  computed: {
    // filteredCities () {
    //   return this.filteredCityEntries
    // },
    filteredSchools () {
      return this.filteredSchoolsEntries
    },
    ...mapGetters(['user', 'userObj', 'schools'])
  },
  watch: {
    populateCities (value) {
      console.log(value)
      value?.length && (this.filteredCityEntries = selectedCities)
    }
  },
  methods: {
    ...mapActions(['getSchools', 'updateUser', 'toggleDialog', 'getUser']),

    async onLicenceChange () {
      console.log(this.licence)
      if (this.licence) {
        /** Upload the file to the cloud and get the URL */
        var name = this.licence.name
        name = name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
        var parseFile = new Parse.File(name, this.licence)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')
        await parseFile
          .save()
          .then(() => {
            console.log(parseFile._url)
            this.licenceURL = parseFile._url
          })
          .catch(console.log)
      }
    },
    onInstructorLicenceChange () {
      const reader = new FileReader()
      if (this.instructorLicence) {
        /** Upload the file to the cloud and get the URL */
        var name = this.instructorLicence.name
        name = name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
        var parseFile = new Parse.File(name, this.instructorLicence)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save()
          .then(() => {
            this.instructorLicenceURL = parseFile._url
            console.log(this.instructorLicenceURL)
          })
          .catch(console.log)
      }
    },

    onInstructorDriverAbstractChange () {
      const reader = new FileReader()
      if (this.instructorDriverAbstract) {
        /** Upload the file to the cloud and get the URL */
        var name = this.instructorDriverAbstract.name
        name = name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
        var parseFile = new Parse.File(name, this.instructorDriverAbstract)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save()
          .then(() => {
            this.instructorDriverAbstractURL = parseFile._url
          })
          .catch(console.log)
      }
    },

    onInstructorSafetyChange () {
      const reader = new FileReader()
      if (this.instructorSafety) {
        /** Upload the file to the cloud and get the URL */
        var name = this.instructorSafety.name
        name = name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
        var parseFile = new Parse.File(name, this.instructorSafety)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save()
          .then(() => {
            this.instructorSafetyURL = parseFile._url
            console.log(this.instructorSafetyURL)
          })
          .catch(console.log)
      }
    },
    onInstructor2MilLiabilityChange () {
      const reader = new FileReader()
      if (this.instructor2MilLiability) {
        /** Upload the file to the cloud and get the URL */
        var name = this.instructor2MilLiability.name
        name = name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
        var parseFile = new Parse.File(name, this.instructor2MilLiability)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save()
          .then(() => {
            this.instructor2MilLiabilityURL = parseFile._url
          })
          .catch(console.log)
      }
    },

    async submit () {
      if (this.$refs.professionalInfo.validate()) {
        console.log(this.userType)
        if (this.userType === 'instructor') {
          await this.updateUser({
            uploadLicence: this.licenceURL,
            uploadInstructorLicence: this.instructorLicenceURL,
            instructorDriverAbstract: this.instructorDriverAbstractURL,
            instructorSafety: this.instructorSafetyURL,
            instructor2MilLiability: this.instructor2MilLiabilityURL,
            licenceNumber: this.licenceNumber,
            carPlateNumber: this.carPlateNumber.split(','),
            instructorCities: this.cities,
            instructingPlateNumber: this.instructingPlateNumber,
            independent: this.notWithAnySchool
          })
          /** Check if instructor updated their school */
          if (this.school !== '' && this.school !== this.currentSchoolId) {
            const InstructorSchools = Parse.Object.extend('InstructorSchools')
            const saveInstructorSchools = new InstructorSchools()
            const SchoolClass = Parse.Object.extend('Schools')
            const schoolsPointerId = new SchoolClass()
            schoolsPointerId.id = this.school
            saveInstructorSchools.set('schoolId', schoolsPointerId)
            if (this.currentInstructorSchoolId !== null) {
              /** Update */
              saveInstructorSchools.id = this.currentInstructorSchoolId
            } else {
              /** Add new one */
              var User = Parse.Object.extend('User')
              var UserPointerId = new User()
              UserPointerId.id = this.user.id
              saveInstructorSchools.set('instructorId', UserPointerId)
            }
            saveInstructorSchools
              .save()
              .then(() => {
                if (this.user) {
                  this.toggleDialog({
                    status: true,
                    title: 'Success',
                    message: 'Professional information updated successfully'
                  })
                }
              })
              .catch(function (e) {
                self.toggleDialog({
                  status: true,
                  title: 'Error',
                  message: e.message
                })
              })
          } else {
            this.toggleDialog({
              status: true,
              title: 'Success',
              message: 'Professional information updated successfully'
            })
          }
        } else {
          /** Student only */
          await this.updateUser({
            uploadLicence: this.licenceURL,
            licenceNumber: this.licenceNumber
          })
          this.toggleDialog({
            status: true,
            title: 'Success',
            message: 'Professional information updated successfully'
          })
        }
      }
    }
  },
  async created () {
    await this.getUser()
    // await this.getSchools();
    // if (this.schools) {
    //   this.filteredSchoolsEntries = await this.schools;
    // }
    // Set user type here from user
    this.userType = localStorage.getItem('userType')
    /** Get Instructor school */
    if (this.userType === 'instructor') {
      const self = this

      this.cities = self.user.get('instructorCities') || []
      if (self.user.get('independent')) {
        this.notWithAnySchool = self.user.get('independent')
      } else {
        const InstructorSchools = Parse.Object.extend('InstructorSchools')
        const query = new Parse.Query(InstructorSchools)
        query.include('schoolId')
        const User = Parse.Object.extend('User')
        const UserPointerId = new User()
        UserPointerId.id = this.user.id
        query.equalTo('instructorId', UserPointerId)
        await query.first().then((school) => {
          console.log(school)
          if (school) {
            self.school = school.get('schoolId').id
            self.currentSchoolId = school.get('schoolId').id
            // self.currentInstructorSchoolId = school.id;
          }
        })
      }
      this.instructorLicenceURL = this.user.get('uploadInstructorLicence')
        ? this.user.get('uploadInstructorLicence')
        : ''
      this.instructorDriverAbstractURL = this.user.get(
        'instructorDriverAbstract'
      )
        ? this.user.get('instructorDriverAbstract')
        : ''

      this.instructorSafetyURL = this.user.get('instructorSafety')
        ? this.user.get('instructorSafety')
        : ''
      this.instructor2MilLiabilityURL = this.user.get('instructor2MilLiability')
        ? this.user.get('instructor2MilLiability')
        : ''
    }
    this.licenceNumber = this.user.get('licenceNumber')
      ? this.user.get('licenceNumber')
      : ''
    this.licenceURL = this.user.get('uploadLicence')
      ? this.user.get('uploadLicence')
      : ''
    // this.userType === 'instructor' &&
    //   (this.carPlateNumber = this.user.get('carPlateNumber').join(','))
    this.carPlateNumber = this.user.get('carPlateNumber')
      ? this.user.get('carPlateNumber').join(',')
      : ''
    this.instructingPlateNumber = this.user.get('instructingPlateNumber')
      ? this.user.get('instructingPlateNumber')
      : ''
    // @todo: until typed in the cities, it doesn't show default value
  }
}
</script>
